import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  count: {
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  removeButton: {
    minWidth: 100,
  },
}));
